"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Control } from "react-hook-form";
import type { MeetingFormValues } from "../../types/meeting-form";

interface MeetingDescriptionProps {
  control: Control<MeetingFormValues>;
  isSubmitting: boolean;
}

export const MeetingDescription: React.FC<MeetingDescriptionProps> = ({ control, isSubmitting }) => {
  return (
    <FormField
      control={control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Agenda/Description (Optional)</FormLabel>
          <FormControl>
            <Textarea
              placeholder="Meeting agenda, topics to discuss, or purpose..."
              className="min-h-[100px] resize-y"
              {...field}
              disabled={isSubmitting}
            />
          </FormControl>
          <FormDescription>
            What will be discussed or the purpose of the meeting
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
